/* v10-analytics.js — el embudo del lote v10, medido entero (sesión D,
   25 oct 2026). Lo cargan la ficha v10 y la bolsa v10; se protege solo
   contra la segunda ejecución (`acaciasupplies.v10analytics`).

   SOLO `Shopify.analytics.publish(nombre, datos)`: ningún script de
   terceros, ninguna cookie propia. Lo recoge el custom pixel del admin
   (Ajustes → Eventos de clientes). Si `Shopify.analytics` no existe (una
   vista previa, un bloqueador, el motor local de las pasadas), no se manda
   nada y se dice UNA vez por consola con `console.warn`: no rompe nada.

   CONSENTIMIENTO, igual que `assets/capture.js`:
   `Shopify.customerPrivacy.analyticsProcessingAllowed()`. Con permiso, se
   publica; sin él, no. Si la API aún no ha llegado (la carga `consent.js`),
   los eventos esperan en una cola: se publican si llega con permiso, se
   tiran si llega sin él; la elección del banner (`visitorConsentCollected`)
   decide la cola en el acto; a los diez segundos sin API la cola se tira y
   se dice por consola con el nombre de cada evento (regla 12).

   LOS EVENTOS (todos llevan `state`):
     product_view    al cargar la ficha       { product_id, variant_id, state }
     swatch_change   al cambiar de color      { product_id, variant_id, state, value }
     bag_add         `v10:cart-added`         { variant_id, state, source: card|product|sticky }
     sticky_add      añadir desde la barra    { product_id, variant_id, state }
     bag_view        al abrir la bolsa        { item_count, state: in_stock|preorder|mixed|empty }
     checkout_start  «Checkout» de la bolsa   { item_count, state }
     notify_join     alta en «Notify me»      { product_id, variant_id, state }
     compare_toggle  `v10:compare` (C)        { product_id, selected, state }
     fits_view       «Qué cabe» a la vista    { product_id, state }
     fits_toggle     `v10:fits-toggle` (E)    { product_id, items, state }
     specs_open      abrir la ficha técnica   { product_id, state }
     ask_click       «Ask about this piece»   { product_id, variant_id, state }
   Y todos, además, `path` (la ruta). Las demás piezas los piden con el evento `v10:track` en `document`:
   `detail = { name, payload }`. La ficha deja el producto en
   `acaciasupplies.v10product` para que `fits_*` y `compare_toggle` sepan su
   `state` sin recalcularlo. */
(function (w, d) {
  'use strict';
  var as = w.acaciasupplies = w.acaciasupplies || {};
  if (as.v10analytics) return;

  var QUEUE = [];
  var WAIT_MS = 10000;
  var STEP_MS = 250;
  var waited = 0;
  var polling = false;
  var chosen = null;
  var warned = false;

  function warn(what, err) {
    console.warn('v10-analytics: ' + what, err === undefined ? '' : err);
  }

  function consent() {
    var api = w.Shopify && w.Shopify.customerPrivacy;
    if (!api || typeof api.analyticsProcessingAllowed !== 'function') return chosen;
    try {
      return !!api.analyticsProcessingAllowed();
    } catch (err) {
      warn('analyticsProcessingAllowed failed', err);
      return null;
    }
  }

  function publish(name, payload) {
    var a = w.Shopify && w.Shopify.analytics;
    if (!a || typeof a.publish !== 'function') {
      if (!warned) { warned = true; warn('Shopify.analytics is not available; v10 events are not sent (first: ' + name + ')'); }
      return;
    }
    try { a.publish(name, payload); } catch (err) { warn('Shopify.analytics.publish failed for ' + name, err); }
  }

  function settle(allowed, why) {
    var pending = QUEUE.splice(0, QUEUE.length);
    if (allowed) pending.forEach(function (e) { publish(e[0], e[1]); });
    else if (allowed === null && pending.length) warn(why + '; not sent: ' + pending.map(function (e) { return e[0]; }).join(', '));
  }

  function poll() {
    if (polling) return;
    polling = true;
    (function tick() {
      var state = consent();
      if (state !== null) { polling = false; settle(state); return; }
      if (!QUEUE.length) { polling = false; return; }
      waited += STEP_MS;
      if (waited >= WAIT_MS) { polling = false; settle(null, 'no consent API after ' + WAIT_MS / 1000 + ' s'); return; }
      w.setTimeout(tick, STEP_MS);
    })();
  }

  function track(name, payload) {
    var p = payload || {};
    if (!p.state) p.state = (as.v10product && as.v10product.state) || 'unknown';
    if (!p.path) p.path = w.location.pathname;
    var state = consent();
    if (state === true) return publish(name, p);
    if (state === false) return;
    QUEUE.push([name, p]);
    poll();
  }

  d.addEventListener('visitorConsentCollected', function (event) {
    var detail = event && event.detail;
    if (!detail || typeof detail.analyticsAllowed !== 'boolean') return;
    chosen = detail.analyticsAllowed;
    settle(chosen);
  });

  function pid() { return as.v10product ? as.v10product.id : null; }

  d.addEventListener('v10:track', function (e) {
    var detail = e.detail || {};
    if (detail.name) track(detail.name, detail.payload);
  });

  d.addEventListener('v10:cart-added', function (e) {
    var detail = e.detail || {};
    track('bag_add', { variant_id: detail.variantId ? String(detail.variantId) : null, state: detail.state || 'unknown', source: detail.source || 'card' });
  });

  /* «Qué cabe» (E): el contrato propuesto es `v10:fits-toggle` en `document`
     con `{ items }`. */
  d.addEventListener('v10:fits-toggle', function (e) {
    var detail = e.detail || {};
    track('fits_toggle', { product_id: pid(), items: detail.items || null });
  });

  /* Comparar (C): el contrato propuesto es `v10:compare` en `document` con
     `{ productId, selected, state }`. */
  d.addEventListener('v10:compare', function (e) {
    var detail = e.detail || {};
    track('compare_toggle', { product_id: detail.productId || null, selected: !!detail.selected, state: detail.state || 'unknown' });
  });

  as.v10analytics = { track: track };
})(window, document);
